import { FC } from 'react';
import FlashSaleLayout from '~/layout/flash-sale-layout';
import { Product } from '~/types/product';

interface IProductsList {
  products: Array<Product>;
}

const HomeFlashSale: FC<IProductsList> = ({ products }) => {
  return (
    <>
      <FlashSaleLayout products={products} />
    </>
  );
};

export default HomeFlashSale;
